<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-11-21 11:55:07
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-12-12 17:29:45
 * @FilePath: \mynewthreejs\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div id="webgl" class="centerCenterBottom"></div>
  </div>
</template>
<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { labelRenderer as labelRenderer2D, tag as tag2D } from "./index";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
// import { onMounted } from "vue";
// import { AxesHelper } from "../js/Three/Three.js";
import * as TWEEN from "three/examples/jsm/libs/tween.module.js";
// import windData from "./wind.json";
import { unzip } from "./zip.js";
import { Loading } from "element-ui";
export default {
  mounted() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    this.$axios({
      url:
        "https://www.moodsci.com/SWDataservice/interface/customApi?para=%3C%22datetime%22:%222024-12-12%2008:00:00%22,%22element%22:%22wind%22,%22dataCode%22:%2255591,55594,55497,55590,55489,55595,55499,55592,55593,56342,56331,56228,56312,56301,56317,56319,56227,56147,56247,56257,56267,56273,56278,56279,56287,56371,56373,56374,S0601,S0607,S0608,S0609,S0610,S0611,S0613,S0614,S0615,S7111,S7147,S7155,S7239,S7386,S8003,S8005,S8006,S8020,S8061,S8181,S8182,S8183,S8184,S8185,S8186,S8196,S8197,S8198,S8210,S8211,S8225,S1422,S0985,S0998,S0904,S1324,S0979%22%3E&apiName=gridService,getGridByGrb2ByZip",
      method: "post"
    }).then(res => {
      // console.log(JSON.parse(unzip(res.data.datas)).gridList[0]);
      let mydata = JSON.parse(unzip(res.data.datas)).gridList[0];
      // console.log(12222);
      this.init(mydata);
      loading.close();
    });
  },

  methods: {
    getTextCanvas1() {
      let texts = [
        {
          name: "北京",
          value: 323
        },
        {
          name: "杭州",
          value: 121
        },
        {
          name: "南京",
          value: 56
        }
      ];
      var width = 512,
        height = 512;
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#0091ff";
      ctx.fillRect(0, 0, width, height);
      ctx.font = 50 + 'px "bold';
      ctx.fillStyle = "#ffffff";

      ctx.fillText(`测试模型`, 180, 250);

      return canvas;
    },
    getTextCanvas2() {
      let texts = [
        {
          name: "北京",
          value: 323
        },
        {
          name: "杭州",
          value: 121
        },
        {
          name: "南京",
          value: 56
        }
      ];
      var width = 500,
        height = 250;
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#22ff00";
      ctx.fillRect(0, 0, width, height);
      ctx.font = 50 + 'px "bold';
      ctx.fillStyle = "#ffffff";

      ctx.fillText(`测试模型`, 150, 125);

      return canvas;
    },
    arrChange(num, arr) {
      const newArr = [];
      while (arr.length > 0) {
        newArr.push(arr.splice(0, num));
      }
      return newArr;
    },
    createBox(pos, radius, color) {
      const geometry = new THREE.SphereGeometry(1, 1, 1);
      const object = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({
          color: 0x808080,
          transparent: true,
          side: THREE.DoubleSide
        })
      );
      object.material.color.r = color[0] / 255;
      object.material.color.g = color[1] / 255;
      object.material.color.b = color[2] / 255;
      object.material.opacity = 0.7;
      object.position.x = pos.x;
      object.position.y = pos.y;
      object.position.z = pos.z;
      object.shapeType = "ball";
      return object;
    },

    init(widdata) {
      let windData = [
        { data: widdata.dataU },
        { data: widdata.dataV },
        { data: widdata.dataS }
      ];
      console.log(widdata);
      let scene = new THREE.Scene();

      // 摄像机
      // // 45:视场角度, width / height:Canvas画布宽高比, 1:近裁截面, 3000：远裁截面
      let camera = new THREE.PerspectiveCamera(
        90,
        window.innerWidth / window.innerHeight,
        1,
        3000
      );
      // 相机位置
      camera.position.x = 100;
      camera.position.y = 100;
      camera.position.z = 100;
      //相机观察目标指向Threejs 3D空间中某个位置
      camera.lookAt(1000, 100, 100);

      // 渲染器
      let renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      //设置three.js渲染区域的尺寸(像素px)
      renderer.setSize(window.innerWidth, window.innerHeight);
      // document.body.appendChild(renderer.domElement);
      //画布要插入到的HTML元素
      document.getElementById("webgl").appendChild(renderer.domElement);

      // 设置渲染器渲染阴影效果
      // renderer.setClearColor(new THREE.Color(0x000000));
      // 渲染器允许阴影渲染
      renderer.shadowMap.enabled = true;
      renderer.antialias = true;

      renderer.alpha = true;

      renderer.precision = "mediump";

      // const dir = new THREE.Vector3(10, 1, 0);

      // //normalize the direction vector (convert to vector of length 1)
      // dir.normalize();

      // const origin = new THREE.Vector3(1, 1, 1);
      // const length = 1;
      // const hex = 0xffff00;

      // const arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
      // scene.add(arrowHelper);

      let timedata = 0;
      for (let i = 0; i < 681; i = i + 5) {
        for (let k = 0; k < 161; k = k + 5) {
          for (let y = 0; y < 30; y = y + 10) {
            // console.log({ x: i, y: k, z: y });
            timedata++;
            // const ball = this.createBox({ x: i, y: k, z: y }, 0.1, [255, 0, 0]);
            // scene.add(ball);
            // const material = new THREE.LineBasicMaterial({ color: 0x0000ff });
            // const points = [];
            // points.push(new THREE.Vector3(i, k, y));
            // points.push(
            //   new THREE.Vector3(
            //     i + windData[0].data[i * 136 + k] / 2,
            //     k + windData[1].data[i * 32 + k] / 2,
            //     y
            //   )
            // );

            // const geometry = new THREE.BufferGeometry().setFromPoints(points);
            // const line = new THREE.Line(geometry, material);
            // scene.add(line);
            // // const tween = new TWEEN.Tween(arrowHelper.scale);
            // const tween = new TWEEN.Tween(line.position);
            // console.log(line);

            const dir = new THREE.Vector3(
              windData[0].data[i * 681 + k],
              windData[1].data[i * 681 + k],
              0
            );

            //normalize the direction vector (convert to vector of length 1)
            dir.normalize();

            const origin = new THREE.Vector3(i, k, y);
            let length = 5;
            let hex = 0xffff00;
            if (Math.abs(windData[2].data[i * 681 + k]) > 5) {
              length = 5;
              hex = "red";
            } else if (Math.abs(windData[2].data[i * 681 + k]) > 3) {
              length = 3;
              hex = "green";
            } else if (Math.abs(windData[2].data[i * 681 + k]) > 2) {
              length = 2;
              hex = "blue";
            } else if (Math.abs(windData[2].data[i * 681 + k]) > 1) {
              length = 1;
              hex = "#ff8000";
            }

            const arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
            scene.add(arrowHelper);
            // scene.add(arrowHelper);
            const tween = new TWEEN.Tween(arrowHelper.position);

            tween.to(
              {
                x: i + windData[0].data[i * 681 + k],
                y: k + windData[1].data[i * 681 + k],
                z: y
              },
              2000
            );
            // tweenb.to(
            //   {
            //     x: 90
            //   },
            //   5000
            // );
            tween.repeat(Infinity);
            tween.start();

            // tween.chain(tweenb);
          }
        }
      }
      var axes = new THREE.AxesHelper(20);
      //将坐标轴添加进场景
      scene.add(axes);
      renderer.render(scene, camera);
      const controls = new OrbitControls(camera, renderer.domElement);
      let isAnimationPaused = false;
      // 循环渲染
      function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
        TWEEN.update();
      }
      animate();

      controls.addEventListener("change", function(event) {
        // console.log("change");
        // 暂停动画
        isAnimationPaused = true;
      });
      controls.addEventListener("start", function(event) {
        // console.log("start");
      });
      controls.addEventListener("end", function(event) {
        // console.log("end");
        // 恢复动画
        isAnimationPaused = false;
      });
    }
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
}
.centerCenterBottom {
  width: 100%;
  height: 100%;
}
canvas {
  width: 100%;
  height: 100%;
}
</style>
